import {useAppDispatch} from '../../../redux/hooks';
import React, {useEffect} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {GetClasses, GetSubclasses} from '../../../GraphQL/SystemQueries';
import {
    CreateClassFeature,
    CreateSubclass, CreateSubclassFeature, DeleteClassFeature,
    DeleteSubclass, DeleteSubclassFeature,
    UpdateClassFeature,
    UpdateSubclass, UpdateSubclassFeature
} from '../../../GraphQL/SystemMutations';
import {toast} from 'react-toastify';
import {setActiveContent, setIsAppLoading} from '../../../redux/slices/content/contentSlice';
import Button from '../../../Atoms/Button';
import {DeleteSharp, PlayArrowSharp} from '@mui/icons-material';
import {PopUp} from '../../../Atoms/PopUp';
import {DropDown} from '../../../Atoms/DropDown';
import Input from '../../../Atoms/Input';
import {TextEditor} from '../../../Atoms/TextEditor';
import {ActiveContent} from '../../../redux/slices/content/contentType';
import {toInteger} from 'lodash';
import * as _ from 'lodash';
import {VeneList} from "../../../Atoms/VeneList";

export const Subklassen = () => {
    const dispatch = useAppDispatch();

    const [ subclasses, setSubclasses ] = React.useState<any[]>([]);
    const [ classes, setClasses ] = React.useState<any[]>([]);
    const [ selectedSubclass, setSelectedSubclass ] = React.useState<any>(null);
    const [ deleteSubclassId, setDeleteSubclassId ] = React.useState<number>(0)
    const [ isPopUpVisible, setIsPopUpVisible ] = React.useState<boolean>(false);
    const [ isDeletePopUpVisible, setIsDeletePopUpVisible ] = React.useState(false)

    const {data: classData, loading: classLoading, error: classError} = useQuery(GetClasses, {fetchPolicy: 'network-only'});
    const {data: subclassData, loading: subclassLoading, error: subclassError} = useQuery(GetSubclasses, {fetchPolicy: 'network-only'});
    const [ createSubclassHook, {}] = useMutation(CreateSubclass);
    const [ updateSubclassHook, {}] = useMutation(UpdateSubclass);
    const [ deleteSubclassHook, {}] = useMutation(DeleteSubclass);

    const [ createSubclassFeatureHook, {}] = useMutation(CreateSubclassFeature);
    const [ updateSubclassFeatureHook, {}] = useMutation(UpdateSubclassFeature);
    const [ deleteSubclassFeatureHook, {}] = useMutation(DeleteSubclassFeature);

    useEffect(() => {
        if (classData && !classLoading) {
            const classList = [];
            for (const classObj of classData.getClasses) {
                classList.push({
                    itemValue: classObj.classId,
                    itemText: classObj.className
                })
            }
            setClasses(classList);
        }
    }, [ classData ])

    useEffect(() => {
        if (subclassData && !subclassLoading) {
            setSubclasses(subclassData.getSubclasses);
        }
    }, [ subclassData ])

    useEffect(() => {
        if (subclassError) {
            toast('Fehler beim Laden der Völker')
        }
    }, [ subclassError ])

    useEffect(() => {
        if (subclassLoading) {
            dispatch(setIsAppLoading({isAppLoading: true, loadingText: 'Völker werden geladen...'}))
        } else {
            dispatch(setIsAppLoading({isAppLoading: false, loadingText: ''}))
        }
    }, [ subclassLoading ])

    const editSubclass = (subclass: any) => {
        setSelectedSubclass({
            subclassId: subclass.subclassId,
            subclassName: subclass.subclassName,
            subclassDescription: subclass.subclassDescription,
            subClassSpellCast: subclass.subClassSpellCast,
            Class: {
                classId: subclass.Class.classId,
                className: subclass.Class.className
            },
            SubclassFeature: subclass.SubclassFeature
        });
        setIsPopUpVisible(true)
    }

    const deleteSubclass = (subclass: any) => {
        setDeleteSubclassId(subclass.subclassId);
        setIsDeletePopUpVisible(true);
    }

    const handleUpdateSubclass = async () => {
        const updateData = await updateSubclassHook({
            variables: {
                subclassId: Number(selectedSubclass.subclassId),
                subclassName: selectedSubclass.subclassName,
                subclassDescription: selectedSubclass.subclassDescription,
                subClassSpellCast: selectedSubclass.subClassSpellCast,
                classId: Number(selectedSubclass.Class.classId)
            },
            refetchQueries: [{
                query: GetSubclasses
            }]
        })

        if (!updateData.errors) {
            toast(`Das Subklasse: ${selectedSubclass.subclassName} wurde gespeichert!`);
            setSelectedSubclass(null);
            setIsPopUpVisible(false);
        } else {
            toast(`Fehler beim Speichern des Volks: ${selectedSubclass.subclassName}!`)
        }
    }

    const handleCreateSubclass = async () => {
        const createData = await createSubclassHook({
            variables: {
                subclassName: selectedSubclass.subclassName,
                subclassDescription: selectedSubclass.subclassDescription,
                classId: Number(selectedSubclass.Class.classId),
                subClassSpellCast: selectedSubclass.subClassSpellCast,
            },
            refetchQueries: [{
                query: GetSubclasses
            }]
        })

        if (!createData.errors) {
            toast(`Das Subklasse: ${selectedSubclass.subclassName} wurde erstellt!`);
            setSelectedSubclass(null);
            setIsPopUpVisible(false);
        } else {
            toast(`Fehler beim erstellen des Volks: ${selectedSubclass.subclassName}!`)
        }
    }

    const handleDeleteSubclass = async () => {
        const deleteData = await deleteSubclassHook({
            variables: {
                subclassId: Number(deleteSubclassId),
            },
            refetchQueries: [{
                query: GetSubclasses
            }]
        })

        if (!deleteData.errors) {
            toast(`Das Subklasse wurde erfolgreich gelöscht!`)
        } else {
            toast(`Fehler beim Löschen des Volkes!`)
        }

        setDeleteSubclassId(0);
        setIsDeletePopUpVisible(false);
    }

    const handleClosePopUp = () => {
        setSelectedSubclass(null);
        setIsPopUpVisible(false)
    }

    const saveSubclassFeature = async (classFeature: any) => {
        let response;
        if (classFeature.subclassFeatureId === 0) {
            response= await createSubclassFeatureHook({
                variables: {
                    subclassFeatureName: classFeature.subclassFeatureName,
                    subclassFeatureDesc: classFeature.subclassFeatureDesc,
                    onLevel: toInteger(classFeature.onLevel),
                    subclassId: toInteger(selectedSubclass.subclassId)
                },
                refetchQueries: [{
                    query: GetSubclasses
                }]
            })
        } else {
            response = await updateSubclassFeatureHook({
                variables: {
                    subclassFeatureId: toInteger(classFeature.subclassFeatureId),
                    subclassFeatureName: classFeature.subclassFeatureName,
                    subclassFeatureDesc: classFeature.subclassFeatureDesc,
                    onLevel: toInteger(classFeature.onLevel),
                    subclassId: toInteger(selectedSubclass.subclassId)
                },
                refetchQueries: [{
                    query: GetSubclasses
                }]
            })
        }

        if (response.errors) {
            toast('Fehler beim Speichern des Features')
        } else {
            toast('Feature gespeichert')
        }
    }

    const deleteSubclassFeature = async(subclassFeatureId: number) => {
        const response = await deleteSubclassFeatureHook({
            variables: {
                subclassFeatureId: toInteger(subclassFeatureId)
            },
            refetchQueries: [{
                query: GetSubclasses
            }]
        })

        if (response.errors) {
            toast('Fehler beim Speichern des Features')
        } else {
            toast('Feature gespeichert')
        }
    }

    const renderOneSubclassFeature = (classFeature: any, index: number) => {
        return (
            <div className='abilityContainer mt-3'>
                <div className='row justify-content-end'>
                    <div className='col-2 text-end'>
                        <Button onClick={ async () => await deleteSubclassFeature(classFeature.subclassFeatureId)}>
                            Löschen
                        </Button>
                    </div>
                    <div className='col-2 text-end'>
                        <Button onClick={ async() => await saveSubclassFeature(classFeature)}>
                            Speichern
                        </Button>
                    </div>
                </div>
                <Input label="Level" type="number" value={classFeature.onLevel} minValue={1} maxValue={20} onChange={(e: any) => {
                    let updatedClassFeature = _.cloneDeep(selectedSubclass.SubclassFeature);
                    updatedClassFeature[index].onLevel = e.target.value;
                    setSelectedSubclass({
                        ...selectedSubclass,
                        SubclassFeature: updatedClassFeature
                    });
                }}/>
                <Input label="Name" type="text" value={classFeature.subclassFeatureName} onChange={(e: any) => {
                    let updatedClassFeature = _.cloneDeep(selectedSubclass.SubclassFeature);
                    updatedClassFeature[index].subclassFeatureName = e.target.value;
                    setSelectedSubclass({
                        ...selectedSubclass,
                        SubclassFeature: updatedClassFeature
                    });
                }}/>
                <TextEditor label="Beschreibung" onChange={ (e) => {
                    let updatedClassFeature = _.cloneDeep(selectedSubclass.SubclassFeature);
                    if (e != updatedClassFeature[index].subclassFeatureDesc) {
                        updatedClassFeature[index].subclassFeatureDesc = e;
                        setSelectedSubclass({
                            ...selectedSubclass,
                            SubclassFeature: updatedClassFeature
                        });
                    }
                }} value={classFeature.subclassFeatureDesc}/>
            </div>
        )
    }

    const renderAllSubclassFeatures = () => {
        const classFeatureHMTL = [];
        let index = 0;
        for (const classFeature of selectedSubclass.SubclassFeature) {
            classFeatureHMTL.push(renderOneSubclassFeature(classFeature, index));
            index++
        }

        return classFeatureHMTL
    }

    const addNewSubclassFeature = () => {
        let updatedClassFeatures = _.cloneDeep(selectedSubclass.SubclassFeature);
        updatedClassFeatures.push({
            subclassFeatureId:   0,
            subclassFeatureName: '',
            subclassFeatureDesc: '',
            onLevel:          1
        });
        setSelectedSubclass({
            ...selectedSubclass,
            SubclassFeature: updatedClassFeatures
        })
    }

    return (
        <div>
            {(selectedSubclass !== null && isPopUpVisible) && (
                <PopUp onClose={handleClosePopUp} title='Subklasse bearbeiten'>
                    <div className='row justify-content-end'>
                        <div className='col-2'>
                            <Button onClick={ async () => selectedSubclass.subclassId > 0? await handleUpdateSubclass() : await handleCreateSubclass() }>{selectedSubclass.subclassId > 0 ? 'Speichern' : 'Erstellen'}</Button>
                        </div>
                    </div>
                    <div className='row mt-3 justify-content-center'>
                        <div className='col-1'>
                            <label>Name:</label>
                        </div>
                        <div className='col-11'>
                            <Input value={selectedSubclass.subclassName} onChange={(e) => setSelectedSubclass({
                                ...selectedSubclass,
                                subclassName: e.target.value,
                            })}/>
                        </div>
                        <div className='col-1 mt-2'>
                            <label>Klasse:</label>
                        </div>
                        <div className='col-11 mt-2'>
                            <DropDown value={selectedSubclass.Class.classId} setValue={(event) => {
                                setSelectedSubclass({
                                    ...selectedSubclass,
                                    Class: {
                                        classId: event.target.value,
                                        className: event.target.name
                                    }
                                })
                            }} items={classes}/>
                        </div>
                        <div className='col-1'>
                            Spellcast:
                        </div>
                        <div className='col-11'>
                            <Input value={selectedSubclass.subClassSpellCast} onChange={(e) => setSelectedSubclass({
                                ...selectedSubclass,
                                subClassSpellCast: e.target.value,
                            })}/>
                        </div>
                        <div className='col-1'>
                            <label>Beschreibung:</label>
                        </div>
                        <div className='col-11'>
                            <TextEditor value={selectedSubclass.subclassDescription} onChange={(value) => {
                                if (selectedSubclass.subclassDescription !== value) {
                                    setSelectedSubclass({
                                        ...selectedSubclass,
                                        subclassDescription: value,
                                    })
                                }
                            }}/>
                        </div>
                        <div className='row text-center'>
                            <div className='col-12 text-center'>
                                <b>Klassen-Features:</b>
                            </div>
                        </div>
                        <div className='row mt-4 classFeatureContainer justify-content-center'>
                            <div className='row col-12'>
                                { renderAllSubclassFeatures() }
                            </div>
                            <div className='col-12'>
                                <Button onClick={ () => addNewSubclassFeature() }>
                                    Hinzufügen
                                </Button>
                            </div>
                        </div>
                    </div>
                </PopUp>
            )}
            {(selectedSubclass === null && !isPopUpVisible) && (
                <div>
                    { isDeletePopUpVisible && (
                        <PopUp onClose={setIsDeletePopUpVisible} title='Subklasse löschen'>
                            <div className='row mt-3 justify-content-center'>
                                <div className='col-12'>
                                    <b>Sind sie sicher, dass sie das Subklasse löschen möchten?</b>
                                </div>
                                <div className='col-2'>
                                    <Button onClick={ async() => await handleDeleteSubclass() }>Löschen</Button>
                                </div>
                                <div className='col-2'>
                                    <Button onClick={() => {
                                        setDeleteSubclassId(0);
                                        setIsDeletePopUpVisible(false)
                                    }}>Abbrechen</Button>
                                </div>
                            </div>
                        </PopUp>
                    )}
                    <div className='row justify-content-between'>
                        <div className='col-2'>
                            <Button onClick={() => dispatch(setActiveContent(ActiveContent.Standardinhalte))}>
                                Zurück
                            </Button>
                        </div>
                        <div className='col-2'>
                            <Button onClick={() => {
                                setSelectedSubclass({
                                    subclassId: 0,
                                    subclassName: '',
                                    subclassDescription: '',
                                    subClassSpellCast: '',
                                    Class: {
                                        classId: 0,
                                        className: ''
                                    },
                                    SubclassFeature: []
                                })
                                setIsPopUpVisible(true)
                            }}>
                                Hinzufügen
                            </Button>
                        </div>
                    </div>
                    <VeneList
                        data={subclasses}
                        colDefinition={[
                            {
                                keyName: "subclassId",
                                colName: "ID"
                            },
                            {
                                keyName: "subclassName",
                                colName: "Name"
                            },
                            {
                                keyName: "className",
                                colName: "Klasse"
                            }
                        ]}
                        buttonConfig={[
                            {
                                icon: <PlayArrowSharp/>,
                                onClick: (dataEntry) => { editSubclass(dataEntry) }
                            },
                            {
                                icon: <DeleteSharp/>,
                                onClick: (dataEntry) => { deleteSubclass(dataEntry) }
                            }
                        ]}
                    />
                </div>
            )}
        </div>
    )
}